import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { cx } from '~/common/utils';
import * as css from './theme.module.scss';
export const Theme = ({ signup, aiv, className, children, ...props }) => {
    const theme = cx(signup && css.signup, aiv && css.rankscale);
    return (_jsx(ThemeContext, { value: theme, children: _jsx("div", { ...props, className: cx(theme, className), children: children }) }));
};
const ThemeContext = createContext(null);
// eslint-disable-next-line react-refresh/only-export-components
export const useThemeContext = () => useContext(ThemeContext);
